import(/* webpackMode: "eager" */ "/var/task/sourcecode/src/app/error.tsx");
